<template>
  <v-card flat class="rrw-filter" :class="{ 'rrw-filter--dark': isDark }">
    <v-card-text class="py-3 px-3">
      <div class="rrw-filter__bar">
        <!-- =============================================================== -->
        <!-- dates component -->
        <div class="rrw-filter__range">
          <svg class="rrw-filter__calendar" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 6H5C3.89543 6 3 6.89543 3 8V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V8C21 6.89543 20.1046 6 19 6Z" stroke="#3F0E40" stroke-width="2" />
            <path d="M3 10C3 8.114 3 7.172 3.586 6.586C4.172 6 5.114 6 7 6H17C18.886 6 19.828 6 20.414 6.586C21 7.172 21 8.114 21 10H3Z" fill="#3F0E40" />
            <path d="M7 3V6M17 3V6" stroke="#3F0E40" stroke-width="2" stroke-linecap="round" />
            <path d="M10.5 12H7.5C7.22386 12 7 12.2239 7 12.5V13.5C7 13.7761 7.22386 14 7.5 14H10.5C10.7761 14 11 13.7761 11 13.5V12.5C11 12.2239 10.7761 12 10.5 12Z" fill="#3F0E40" />
            <path d="M10.5 16H7.5C7.22386 16 7 16.2239 7 16.5V17.5C7 17.7761 7.22386 18 7.5 18H10.5C10.7761 18 11 17.7761 11 17.5V16.5C11 16.2239 10.7761 16 10.5 16Z" fill="#3F0E40" />
            <path d="M16.5 12H13.5C13.2239 12 13 12.2239 13 12.5V13.5C13 13.7761 13.2239 14 13.5 14H16.5C16.7761 14 17 13.7761 17 13.5V12.5C17 12.2239 16.7761 12 16.5 12Z" fill="#3F0E40" />
            <path d="M16.5 16H13.5C13.2239 16 13 16.2239 13 16.5V17.5C13 17.7761 13.2239 18 13.5 18H16.5C16.7761 18 17 17.7761 17 17.5V16.5C17 16.2239 16.7761 16 16.5 16Z" fill="#3F0E40" />
          </svg>
          <DateRangeComponent
            class="rrw-filter__picker"
            :default-today="true"
            :append-to-body="true"
            :days-input-changed-to="form.dayNumber"
            @sendDate="handleRangeDate"
          />
          <v-text-field
            v-model="form.dayNumber"
            label="الايام"
            outlined
            dense
            hide-details
            type="number"
            min="1"
            class="rrw-filter__days"
          />
        </div>
        <!-- =============================================================== -->
        <!-- manager picker component -->
        <div class="rrw-filter__field" v-if="showManagerPicker">
          <SelectInput
            label="اسم المدير"
            :originalItems="managerNames"
            @selectedValues="onManagersSelected"
          />
        </div>
        <!-- =============================================================== -->
        <!-- manager readonly component (for sales manager mode)-->
        <div class="rrw-filter__field" v-if="showManagerReadonly">
          <v-text-field
            :value="lockedManagerName"
            label="اسم المدير"
            outlined
            dense
            hide-details
            readonly
          />
        </div>
         <!-- =============================================================== -->
        <!-- status user component -->
        <div class="rrw-filter__field">
          <SelectInput
            ref="statusSelect"
            label="حالة الاستشاري"
            :originalItems="statusSelectItems"
            @selectedValues="onStatusSelected"
          />
        </div>
        <!-- =============================================================== -->
        <!-- adviser picker component -->
        <div class="rrw-filter__field" v-if="showAdviserFilter">
          <SelectInput
            label="اسم الاستشاري"
            :originalItems="agentNames"
            @selectedValues="onAdvisersSelected"
          />
        </div>
        <!-- =============================================================== -->
        <!-- search/compare buttons component -->
        <div class="rrw-filter__actions">
          <v-btn
            color="primary"
            depressed
            class="rrw-filter__btn"
            :loading="loading"
            @click="emitSearch"
          >
            <v-icon left small>mdi-magnify</v-icon>
            بحث
          </v-btn>
          <v-btn
            v-if="showCompareButton"
            outlined
            color="primary"
            class="rrw-filter__btn"
            :loading="compareLoading"
            @click="emitCompare"
          >
            <v-icon left small>mdi-compare</v-icon>
            قارن
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Axios from "axios";
import DateRangeComponent from "@/components/Charts/DateRangeComponent.vue";
import SelectInput from "@/components/Charts/SelectInput.vue";

import {
  REQUESTS_RECEIVED_WEB_REPORT_MODES,
  todayYmd,
} from "@/helper/requestsReceivedWebReportApi.js";
//===============================================================
function defaultForm() {
  return {
    startDate: todayYmd(),
    endDate: todayYmd(),
    dayNumber: "",
    statusUser: 1,
    managerId: [],
    adviserId: [],
  };
}

export default {
  name: "RequestsReceivedWebReportFilter",
  components: { DateRangeComponent, SelectInput },
  props: {
    mode: {
      type: String,
      default: REQUESTS_RECEIVED_WEB_REPORT_MODES.ADMIN, // default mode is admin
      validator: (value) =>
        Object.values(REQUESTS_RECEIVED_WEB_REPORT_MODES).includes(value), // validate mode
    },
    loading: { type: Boolean, default: false }, // loading state
    compareLoading: { type: Boolean, default: false }, // compare loading state
  },
  data() {
    return {
      form: defaultForm(), // default form
      managerNames: [], // manager names
      agentNames: [], // agent names
      selectedManagers: [], // selected managers
      lockedManagerName: localStorage.getItem("loggedIn_user_name") || "", // locked manager name (sales manager mode)
      statusSelectItems: [ // agent status
        { id: 2, value: 2, text: "الكل", color: "#233997" }, // all status
        { id: 0, value: 0, text: "استشاري مؤرشف", color: "#c14e41" }, // archived adviser
        { id: 1, value: 1, text: "استشاري نشط", color: "#648265" }, // active adviser
      ],
    };
  },
  //===============================================================
  computed: {
    isDark() {
      return this.$store.getters.isDark;
    },
    isSalesManagerMode() {
      return this.mode === REQUESTS_RECEIVED_WEB_REPORT_MODES.SALES_MANAGER; // check if mode is sales manager
    },
    userRole() {
      return parseInt(localStorage.getItem("role") || "0", 10);
    },
    showCompareButton() {
      return !this.isSalesManagerMode; // show compare button if mode is not sales manager
    },
    showManagerPicker() {
      return !this.isSalesManagerMode && ![0, 1, 11].includes(this.userRole); // show manager picker if mode is not sales manager 
    },
    showManagerReadonly() {
      return this.isSalesManagerMode; // show manager readonly if mode is sales manager
    },
    showAdviserFilter() {
      if (this.isSalesManagerMode) {
        return true;
      }
      return [4, 7].includes(this.userRole); // show adviser filter if user role is consultant or sales manager
    },
    lockedManagerId() {
      return parseInt(localStorage.getItem("id") || "0", 10);
    },
    defaultStatusItem() {
      return (
        this.statusSelectItems.find((item) => item.value === this.form.statusUser) ||
        this.statusSelectItems[2]
      );
    },
  },
  watch: {
    //===============================================================
    // load agents when form status user changes or selected managers changes
    "form.statusUser"(val) {
      this.loadAgents(val);
    },
    selectedManagers() {
      this.loadAgents(this.form.statusUser);
    },
    "form.dayNumber"(val) {
      const days = parseInt(val, 10);
      if (!days || days < 1) {
        return;
      }
      const end = new Date();
      end.setHours(0, 0, 0, 0);
      const start = new Date(end);
      start.setDate(start.getDate() - days);
      this.form.endDate = this.formatYmd(end);
      this.form.startDate = this.formatYmd(start);
    },
    //===============================================================
  },
  mounted() {
    if (this.isSalesManagerMode) {
      this.applySalesManagerScope();
    } else if (this.showManagerPicker) {
      this.loadManagers();
    }
    this.loadAgents(this.form.statusUser);
    this.$nextTick(() => {
      this.setDefaultStatusSelection();
    });
    this.$emit("search", this.getPayload()); // emit search event with form payload
  },
  methods: {
    setDefaultStatusSelection() {
      const statusRef = this.$refs.statusSelect;
      if (!statusRef) {
        return;
      }
      statusRef.model = [this.defaultStatusItem];
    },
    onStatusSelected(values) {
      const selected = values || [];
      if (selected.length > 1) {
        const latest = selected[selected.length - 1];
        if (this.$refs.statusSelect) {
          this.$refs.statusSelect.model = [latest];
        }
        this.form.statusUser = latest.value;
        return;
      }
      if (selected.length === 1) {
        this.form.statusUser = selected[0].value;
        return;
      }
      this.form.statusUser = 1;
      this.$nextTick(() => {
        this.setDefaultStatusSelection();
      });
    },
    applySalesManagerScope() {
      if (!this.lockedManagerId) {
        return;
      }
      this.form.managerId = [this.lockedManagerId];
      this.selectedManagers = [
        { id: this.lockedManagerId, name: this.lockedManagerName },
      ];
    },
    getPayload() {
      if (this.isSalesManagerMode && this.lockedManagerId) { // if mode is sales manager and locked manager id is set
        this.form.managerId = [this.lockedManagerId];
      }
      return {
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        statusUser: this.form.statusUser,
        managerId: [...this.form.managerId],
        adviserId: [...this.form.adviserId],
      };
    },
    emitSearch() {
      this.$emit("search", this.getPayload());
    },
    emitCompare() {
      this.$emit("compare", this.getPayload());
    },
    handleRangeDate(val) {
      this.form.startDate = val && val.startDate ? val.startDate : null;
      this.form.endDate = val && val.endDate ? val.endDate : null;
    },
    formatYmd(date) {
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${date.getFullYear()}-${month}-${day}`;
    },
    onManagersSelected(values) {
      this.selectedManagers = values || [];
      this.form.managerId = this.selectedManagers.map((item) =>
        typeof item === "object" ? item.id : item
      );
    },
    onAdvisersSelected(values) {
      this.form.adviserId = (values || []).map((item) =>
        typeof item === "object" ? item.id : item
      );
    },
    getManagerIdsForAgentsRequest() {
      if (this.isSalesManagerMode && this.lockedManagerId) {
        return [{ id: this.lockedManagerId }];
      }
      return this.selectedManagers;
    },
    loadManagers() {
      const body = new FormData();
      body.append("role", "manager");
      Axios.post(`${this.$store.state.url}/employee/admin/filterUsers`, body, {
        headers: this.request_headers(),
      }).then((res) => {
        this.managerNames = (res.data.payload || []).map((item) => ({
          ...item,
          text: item.name,
          color: "red",
        }));
      });
    },
    loadAgents(statusUser) {
      const body = new FormData();
      body.append("role", "agent");
      body.append("is_customer_service", 0);
      if (statusUser !== 2) {
        body.append("status", statusUser);
      }

      this.getManagerIdsForAgentsRequest().forEach((item, index) => {
        body.append(`manager_id[${index}]`, item.id);
      });

      Axios.post(`${this.$store.state.url}/employee/admin/filterUsers`, body, {
        headers: this.request_headers(),
      }).then((res) => {
        this.agentNames = (res.data.payload || []).map((item) => ({
          ...item,
          text: item.name,
          color: "red",
        }));
      });
    },
  },
};
</script>

<style scoped lang="scss">
.rrw-filter {
  border: 1px solid #ececec;
  border-radius: 12px;
  background: #fff;
  margin-bottom: 16px;

  &--dark {
    background: #1e1e1e;
    border-color: #3a3a3a;
    color: #e8eaed;
  }

  &__bar {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
    overflow: visible;
  }

  &__range {
    position: relative;
    display: flex;
    align-items: center;
    flex: 1.6 1 280px;
    min-width: 250px;
  }

  &__field {
    flex: 1 1 150px;
    min-width: 140px;
  }

  &__actions {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    gap: 8px;
  }

  &__btn {
    height: 40px;
    min-width: 88px;
    font-weight: 700;
  }

  &__calendar {
    position: absolute;
    z-index: 2;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    pointer-events: none;
  }

  &__picker {
    flex: 1;
    min-width: 0;
  }

  &__days {
    flex: 0 0 72px;
    width: 72px;
    max-width: 72px;
    margin-right: 8px;
  }
}

.rrw-filter ::v-deep .container {
  padding: 0 !important;
  margin: 0 !important;
  max-width: 100%;
}

.rrw-filter ::v-deep .selectInput .v-input__slot,
.rrw-filter ::v-deep .rrw-filter__days .v-input__slot,
.rrw-filter ::v-deep .rrw-filter__field .v-input__slot {
  min-height: 40px !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.rrw-filter ::v-deep .v-text-field__details {
  display: none;
}

.rrw-filter ::v-deep .rangePicker .reportrange-text {
  height: 40px !important;
  padding: 8px 36px 8px 8px !important;
}

.rrw-filter--dark ::v-deep .v-label,
.rrw-filter--dark ::v-deep .v-select__selections,
.rrw-filter--dark ::v-deep input {
  color: #e8eaed !important;
}
</style>
